import React, { FC } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass as faSearch } from '@fortawesome/free-solid-svg-icons';
import './SwitchToSearch.css';

export interface SwitchToSearchProps {
	refSearch: React.RefObject<HTMLDivElement>,
    refProfile: React.RefObject<HTMLDivElement>,
};

const SwitchToSearch: FC<SwitchToSearchProps> = ({ refSearch, refProfile }) => {

    const onClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if(refSearch.current) {
            refSearch.current.className = 'Left appear';
            refSearch.current.style.zIndex = '10';
        }
        if(refProfile.current) {
            refProfile.current.className = 'Right';
            refProfile.current.style.zIndex = '0';
        }
    };

    return (
		<div className='SwitchToSearch' onClick={onClick}>
            <Icon icon={faSearch} fixedWidth/>
	    </div>
    );
};

export default SwitchToSearch;
